import React from 'react';
import { FaPrint } from 'react-icons/fa';

const PrintableContent = ({ person }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <style>
        {`
          @media screen {
            .print-content {
              display: none;
            }
          }
          @media print {
            @page {
              margin: 0.5in;
            }
            body * {
              visibility: hidden;
            }
            .print-content, .print-content * {
              visibility: visible;
            }
            .print-content {
              display: block;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
            .no-print {
              display: none;
            }
            .print-section {
              break-inside: avoid;
              margin-bottom: 1rem;
              padding: 0.5rem;
              border: 1px solid #e5e7eb;
              border-radius: 0.375rem;
              background-color: white;
            }
            .print-header {
              text-align: center;
              padding: 0.5rem;
              margin-bottom: 1rem;
              border-bottom: 1px solid #e5e7eb;
              font-size: 1.5rem;
            }
            .print-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 1rem;
            }
            .print-info-row {
              display: flex;
              padding: 0.25rem 0;
              border-bottom: 1px solid #f3f4f6;
              font-size: 0.875rem;
            }
            .print-info-label {
              font-weight: 600;
              width: 40%;
              color: #374151;
            }
            .print-info-value {
              width: 60%;
            }
            .print-notes {
              background-color: #f9fafb;
              padding: 0.5rem;
              border-radius: 0.25rem;
              margin-top: 0.25rem;
              font-size: 0.875rem;
            }
            .print-note-date {
              color: #6b7280;
              font-size: 0.75rem;
              margin-top: 0.25rem;
            }
          }
        `}
      </style>
      <button 
        onClick={handlePrint}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 no-print flex items-center gap-2"
      >
        <FaPrint /> Print
      </button>
      
      <div className="print-content">
        <div className="print-header">
          <h1 className="text-2xl font-bold">
            {person.children.firstName} {person.children.lastName}
          </h1>
          <p className="text-base text-gray-600 mt-1">{person.children.class} Class</p>
        </div>

        <div className="print-grid">
          <div className="print-section">
            <h2 className="text-lg font-bold mb-2">Child Information</h2>
            <div className="print-info-row">
              <span className="print-info-label">Birthday</span>
              <span className="print-info-value">{new Date(person.children.dateOfBirth).toLocaleDateString()}</span>
            </div>
            <div className="print-info-row">
              <span className="print-info-label">Priority Status</span>
              <span className="print-info-value">{person.enquiry.priority ? "Yes" : "No"}</span>
            </div>
            <div className="print-info-row">
              <span className="print-info-label">Allergies</span>
              <span className="print-info-value">
                {person.children.allergies || "None"}
              </span>
            </div>
          </div>

          <div className="print-section">
            <h2 className="text-lg font-bold mb-2">Parent Information</h2>
            <div className="print-info-row">
              <span className="print-info-label">Name</span>
              <span className="print-info-value">{person.parent.parentFirstName} {person.parent.parentLastName}</span>
            </div>
            <div className="print-info-row">
              <span className="print-info-label">Email</span>
              <span className="print-info-value">{person.parent.email || "None"}</span>
            </div>
            <div className="print-info-row">
              <span className="print-info-label">Phone</span>
              <span className="print-info-value">{person.parent.phone || "None"}</span>
            </div>
          </div>
        </div>

        <div className="print-section">
          <h2 className="text-lg font-bold mb-2">Enrollment Information</h2>
          <div className="print-grid">
            <div>
              <div className="print-info-row">
                <span className="print-info-label">Enquiry Date</span>
                <span className="print-info-value">{new Date(person.enquiry.enquiryDate).toLocaleDateString()}</span>
              </div>
              <div className="print-info-row">
                <span className="print-info-label">Desired Enrollment</span>
                <span className="print-info-value">{new Date(person.enquiry.desiredEnrollmentDate).toLocaleDateString()}</span>
              </div>
            </div>
            <div>
              <div className="print-info-row">
                <span className="print-info-label">Status</span>
                <span className="print-info-value">{person.enquiry.status}</span>
              </div>
              <div className="print-info-row">
                <span className="print-info-label">Waitlist</span>
                <span className="print-info-value">{person.enquiry.whichWaitlist}</span>
              </div>
            </div>
          </div>
        </div>

        {person.children.siblings.length > 0 && (
          <div className="print-section">
            <h2 className="text-lg font-bold mb-2">Siblings</h2>
            <div className="print-info-row">
              <ul className="list-disc ml-4">
                {person.children.siblings.map((sibling, index) => (
                  <li key={index} className="mb-1">{sibling}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="print-section">
          <h2 className="text-lg font-bold mb-2">Notes</h2>
          {person.children.notes.length > 0 ? (
            person.children.notes.map((note, index) => (
              <div key={index} className="print-notes mb-2">
                <p>{note.content}</p>
                <p className="print-note-date">{new Date(note.timestamp).toLocaleDateString()}</p>
              </div>
            ))
          ) : (
            <p>No notes available</p>
          )}
        </div>
      </div>
    </>
  );
};

export default PrintableContent;
